import { Component, OnInit } from '@angular/core';
import { UserService } from '../user/user.service';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
    constructor(public userService: UserService) {}
    ngOnInit(): void {}
}
